import { combineReducers } from '@reduxjs/toolkit';
import coreReducer, {
  checkLocatorApiHealthAsync,
  fetchLocatorFlowsAsync,
  loadDriftIgnoreListAsync,
  loadLocatorPrioritiesAsync,
  setActiveTab,
  setPlatform,
} from './locatorCoreSlice';
import runsReducer, {
  appendRunLog,
  pollLocatorRunAsync,
  resetRun,
  runLocatorScenarioAsync,
} from './locatorRunsSlice';
import historyReducer, {
  deleteLocatorHistoryFileAsync,
  loadLatestLocatorResultAsync,
  loadLocatorFileAsync,
  loadLocatorHistoryAsync,
} from './locatorHistorySlice';
import screenDriftReducer, {
  addIgnoredLocatorAsync,
  compareScreenDriftAsync,
  fetchScreenDriftGroupedAsync,
  setScreenDriftShowIgnored,
  setScreenDriftShowTestImpactOnly,
} from './screenDriftSlice';
import analyticsDriftReducer, {
  addIgnoredBeaconAsync,
  compareAnalyticsDriftAsync,
  fetchAnalyticsDriftGroupedAsync,
  setAnalyticsDriftShowIgnored,
} from './analyticsDriftSlice';
import healingReducer, {
  clearHealRunReport,
  loadHealingAsync,
  resolveHealingEventAsync,
  runHealAllAsync,
  setHealingHideLowSignal,
  setHealingSort,
} from './healingSlice';
import versionDiffReducer, { compareVersionDiffAsync } from './versionDiffSlice';

const locatorDriftReducer = combineReducers({
  core: coreReducer,
  // Start unused Locator Drift scenario runner reducer.
  // Retained for the non-batch runner flow, although the current LocatorDriftPage UI does not render it.
  runs: runsReducer,
  // End unused Locator Drift scenario runner reducer.
  history: historyReducer,
  screenDrift: screenDriftReducer,
  analyticsDrift: analyticsDriftReducer,
  healing: healingReducer,
  versionDiff: versionDiffReducer,
});

export {
  addIgnoredBeaconAsync,
  addIgnoredLocatorAsync,
  appendRunLog,
  checkLocatorApiHealthAsync,
  compareAnalyticsDriftAsync,
  compareScreenDriftAsync,
  compareVersionDiffAsync,
  clearHealRunReport,
  deleteLocatorHistoryFileAsync,
  fetchAnalyticsDriftGroupedAsync,
  fetchLocatorFlowsAsync,
  fetchScreenDriftGroupedAsync,
  loadDriftIgnoreListAsync,
  loadHealingAsync,
  loadLatestLocatorResultAsync,
  loadLocatorFileAsync,
  loadLocatorHistoryAsync,
  loadLocatorPrioritiesAsync,
  pollLocatorRunAsync,
  resetRun,
  resolveHealingEventAsync,
  runLocatorScenarioAsync,
  runHealAllAsync,
  setActiveTab,
  setAnalyticsDriftShowIgnored,
  setHealingHideLowSignal,
  setHealingSort,
  setPlatform,
  setScreenDriftShowIgnored,
  setScreenDriftShowTestImpactOnly,
};

//core
export const selectActiveTab = (state) => state.locatorDrift.core.activeTab;
export const selectPlatform = (state) => state.locatorDrift.core.platform;
export const selectIgnoreList = (state) => state.locatorDrift.core.ignoreList;
export const selectPriorities = (state) => state.locatorDrift.core.priorities;

//history
export const selectLatestResult = (state) => state.locatorDrift.history.latestResult;
export const selectResultLoading = (state) => state.locatorDrift.history.resultLoading;
export const selectResultError = (state) => state.locatorDrift.history.resultError;
export const selectHistoryFiles = (state) => state.locatorDrift.history.historyFiles;
export const selectHistoryLoading = (state) => state.locatorDrift.history.historyLoading;
export const selectHistoryError = (state) => state.locatorDrift.history.historyError;
export const selectActiveHistoryFile = (state) => state.locatorDrift.history.activeHistoryFile;

//screenDrift
export const selectScreenDrift = (state) => state.locatorDrift.screenDrift;
export const selectAnalyticsDrift = (state) => state.locatorDrift.analyticsDrift;
export const selectHealingLoading = (state) => state.locatorDrift.healing.loading;
export const selectHealingError = (state) => state.locatorDrift.healing.error;
export const selectHealingStats = (state) => state.locatorDrift.healing.stats;
export const selectHealingEvents = (state) => state.locatorDrift.healing.events;
export const selectHealingSort = (state) => state.locatorDrift.healing.sort;
export const selectHealingHideLowSignal = (state) => state.locatorDrift.healing.hideLowSignal;
export const selectHealingResolvingId = (state) => state.locatorDrift.healing.resolvingId;
export const selectHealRunLoading = (state) => state.locatorDrift.healing.healRunLoading;
export const selectHealRunError = (state) => state.locatorDrift.healing.healRunError;
export const selectHealRunReport = (state) => state.locatorDrift.healing.healRunReport;
export const selectVersionDiff = (state) => state.locatorDrift.versionDiff;

// Start unused Locator Drift scenario runner selectors.
// Retained for the non-batch runner flow, although the current LocatorDriftPage UI does not render it.
export const selectLocatorFlows = (state) => state.locatorDrift.core.flows;
export const selectLocatorRun = (state) => state.locatorDrift.runs;
// End unused Locator Drift scenario runner selectors.

export default locatorDriftReducer;
